var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGraphicsEmpty = function SvgGraphicsEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 249 270",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.1 0h9.15v9.12a8.1 8.1 0 0 1-8.1 8.1H0V8.1A8.1 8.1 0 0 1 8.1 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M112.68 98.31l102.59 28.19v98.65l-102.59-44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M112.8 98.41L29 121.83v103.65l83.8-44.87z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#17BF64",
    strokeDasharray: "6 7",
    strokeWidth: 3,
    d: "M166.76 218.08c-23.15-6.78-63.82-6.17-79.09-45.78-14-36.3 37.64-71.25 52.08-55.95 10.24 10.84-2.88 26.47-21.09 24.72-20.49-1.98-32.6-20.3-28.56-40.02 8.01-39.1 69.63-64.96 72.23-66.77"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M25.66 26.63c-.39-9.8-1.88-16-4.48-18.6A9.98 9.98 0 0 0 7.06 22.17c2.6 2.6 8.8 4.08 18.6 4.47zM28.78 32.52c.39 9.8 1.88 16 4.47 18.6a9.98 9.98 0 0 0 14.12-14.13c-2.6-2.6-8.79-4.08-18.6-4.47z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.88 20.03)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#CCC",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M3.63.91h2.72v19.94H3.63z",
    mask: "url(#b)",
    transform: "rotate(-45 5 10.87)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M2.43.26l1.92-1.93 14.1 14.1-1.93 1.93z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.9,
    d: "M47.38 15.72l6.63-1.58M44.66 13l2.55-6.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.85,
    cy: 18.22,
    fill: "#666",
    rx: 7.26,
    ry: 7.25
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M29 122.01l102.6 32.56v114.96L29 225.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M215.79 126.38l-85.65 28.19v114.96l85.65-44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M215.55 126.31l33.1 44.31-87.86 34.63-30.35-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M28.88 121.77L.2 166.51l101.07 38.74 29.53-50.96z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraphicsEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GraphicsEmpty.8fff5426.svg";
export { ForwardRef as ReactComponent };